import "./Icon.css"; //CSS!
import Icons from "../../../img/icons.svg";

export default (props) => {
  const image = props.image? props.image : false;
  const title = props.title? props.title : false;
  const size = props.size? props.size : "s"; //xs-s-m-l-xl-xxl
  const layout = props.layout? props.layout : "horizontal"; //xs-s-m-l-xl-xxl
  const cls = props.className? props.className : "";
  const imgCls = props.imageClassName? props.imageClassName : "";

  return (
    <div className={`Icon Icon_size_${size} Icon_layout_${layout} ${cls}`} style={props.style}>
      {image && (
        <div className={`Icon__image ${imgCls}`}>
          <svg>
            <use xlinkHref={`${Icons}#icon-${image}`} />
          </svg>
        </div>
      )}
      {title && <span className="Icon__title">{title}</span>}
    </div>
  );
};
